// Fehlertext einer Edge Function lesbar machen (Ticket #479, 09.10.2026).
//
// Antwortet eine Function mit Status 4xx/5xx, liefert supabase-js `data = null` und einen
// FunctionsHttpError mit dem englischen Sammeltext "Edge Function returned a non-2xx status
// code". Die Function hatte aber längst erklärt, was fehlt — etwa „Bitte tragen Sie für jeden
// Unterzeichner Name und E-Mail ein." Der steht im Antwort-Body (`error.context`), und den
// holen wir hier heraus. Der englische Sammeltext erreicht den Nutzer nie.

interface MitKontext { context?: unknown }

export async function functionFehlerText(error: unknown, fallback: string): Promise<string> {
  const ctx = (error as MitKontext | null)?.context;
  if (ctx && typeof (ctx as Response).json === 'function') {
    try {
      const body = await (ctx as Response).clone().json();
      const text = body?.fehler ?? body?.error ?? body?.message;
      if (typeof text === 'string' && text.trim()) return text.trim();
    } catch { /* kein JSON im Body — Fallback */ }
  }
  return fallback;
}
